/* Source: storm-mobile-search.js */
function setupStormMobileSearch(scope = document) {
  scope.querySelectorAll('.header:has([data-mobile-search-toggle])').forEach(header => {
    if (header.dataset.mobileSearchReady) return;
    header.dataset.mobileSearchReady = 'true';
    const abort = new AbortController();
    const toggle = header.querySelector('[data-mobile-search-toggle]');
    const field = header.querySelector('.storm-search__input');
    const setOpen = (open, focus = false) => {
      header.toggleAttribute('data-mobile-search-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Aramayı kapat' : 'Aramayı aç');
      if (focus) (open ? field : toggle).focus();
      header.closest('sticky-header')?.setHeaderHeight?.();
    };
    toggle.addEventListener('click', () => setOpen(!header.hasAttribute('data-mobile-search-open'), true), {signal:abort.signal});
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && header.hasAttribute('data-mobile-search-open')) {
        event.stopPropagation();setOpen(false, true);
      }
    }, {signal:abort.signal});
    document.addEventListener('pointerdown', event => {
      if (!header.contains(event.target)) setOpen(false);
    }, {signal:abort.signal});
    const mobile = matchMedia('(max-width:989px)');
    mobile.addEventListener('change', () => setOpen(false), {signal:abort.signal});
    header.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => abort.abort(), {once:true});
  });
}
setupStormMobileSearch();
document.addEventListener('shopify:section:load', event => setupStormMobileSearch(event.target));

;
/* Source: storm-catalogue.js */
if (!customElements.get('storm-catalogue')) {
  customElements.define('storm-catalogue', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      const positionPanel = () => {
        const bottom = this.closest('.header').getBoundingClientRect().bottom;
        this.style.setProperty('--sv-catalogue-top', `${Math.max(0,bottom)}px`);
      };
      this.details.addEventListener('toggle', positionPanel, options);
      window.addEventListener('resize', positionPanel, options);
      window.addEventListener('scroll', positionPanel, {...options,passive:true});
      positionPanel();
      const close = () => { this.details.open = false; };
      this.querySelector('[data-catalogue-close]')?.addEventListener('click', () => { close(); this.summary.focus(); }, options);
      this.addEventListener('pointerenter', (event) => {
        clearTimeout(this.closeTimer);

      }, options);
      this.addEventListener('pointerleave', () => {
        this.closeTimer = setTimeout(() => {
          if (!this.contains(document.activeElement)) close();
        }, 160);
      }, options);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) close(); }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { close(); this.summary.focus(); event.stopPropagation(); }
      }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) close(); }, options);
      this.querySelectorAll('a').forEach((link) => link.addEventListener('click', close, options));
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.closeTimer); }
  });
}

;
/* Source: storm-shopping-ui.js */
if (!customElements.get('storm-recommendation-dock')) {
  customElements.define('storm-recommendation-dock', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.disclosure = this.querySelector('details');
      this.toggle = this.querySelector('[data-picks-toggle]');
      this.items = this.querySelector('.sv-picks-dock__items');
      this.close = this.querySelector('[data-picks-close]');
      const set = (collapsed, persist = true) => {
        this.expectedOpen = !collapsed;
        this.disclosure.open = this.expectedOpen;
        if (persist) try { window.StormPrivacy.storage('session').setItem(this.storageKey, String(collapsed)); } catch {}
      };
      const mobile = matchMedia('(max-width:989px)');
      const restore = () => {
        this.storageKey = mobile.matches ? 'storm-picks-collapsed-mobile' : 'storm-picks-collapsed-desktop';
        let collapsed = mobile.matches;
        try { const saved = window.StormPrivacy.storage('session').getItem(this.storageKey); if (!mobile.matches && saved !== null) collapsed = saved === 'true'; } catch {}
        set(collapsed);
      };
      restore();
      const stopAuto = () => {};
      // The summary's native action stays available before JS loads or if it fails.
      this.toggle.addEventListener('click', stopAuto, {signal:this.abort.signal});
      this.disclosure.addEventListener('toggle', () => {
        if (this.disclosure.open === this.expectedOpen) return;
        this.expectedOpen = this.disclosure.open;
        try { window.StormPrivacy.storage('session').setItem(this.storageKey, String(!this.disclosure.open)); } catch {}
      }, {signal:this.abort.signal});
      this.close.addEventListener('click', () => {stopAuto();set(true);this.toggle.focus();}, {signal:this.abort.signal});
      this.items.addEventListener('pointerdown',stopAuto,{signal:this.abort.signal});
      const change = () => {clearTimeout(this.collapseTimer);restore();};
      if (mobile.addEventListener) mobile.addEventListener('change', change, {signal:this.abort.signal});
      else { mobile.addListener(change);this.abort.signal.addEventListener('abort', () => mobile.removeListener(change), {once:true}); }

    }
    disconnectedCallback() { this.abort?.abort();clearTimeout(this.autoTimer);clearTimeout(this.collapseTimer); }
  });
}

function setupStormNature(scope = document) {
  scope.querySelectorAll('[data-nature-video]').forEach(video => {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    const sync = () => {
      if (visible && !document.hidden && !reduced.matches) {
        const source = video.querySelector('source');
        if (!source.getAttribute('src')) { source.src = source.dataset.src; video.load(); }
        video.play().catch(() => {});
      } else video.pause();
    };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:.15});
    observer.observe(video);
    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', sync);
    video.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { observer.disconnect(); document.removeEventListener('visibilitychange',sync); reduced.removeEventListener('change',sync); });
  });
}
setupStormNature();
document.addEventListener('shopify:section:load', event => setupStormNature(event.target));

// Reserve the actual visible buy-bar height, including wrapped errors and safe areas.
function setupStormFloatingTools() {
  const tools = document.querySelector('[data-floating-tools]');
  if (!tools || tools.dataset.positioned) return;
  tools.dataset.positioned = 'true';
  let frame;
  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const dock = document.querySelector('.sv-buy-dock');
      const rect = dock?.getBoundingClientRect();
      const preview = parseFloat(getComputedStyle(document.body).getPropertyValue('--sv-preview-offset')) || 0;
      const reserved = rect && rect.height > 0 && !dock.hidden ? Math.max(0, innerHeight - rect.top) : preview;
      tools.style.setProperty('--sv-tools-bottom', `${reserved + 16}px`);
    });
  };
  const dock = document.querySelector('.sv-buy-dock');
  const resize = new ResizeObserver(update);
  if (dock) resize.observe(dock);
  const mutation = new MutationObserver(update);
  if (dock) mutation.observe(dock,{attributes:true,attributeFilter:['hidden','class','style']});
  window.addEventListener('resize',update);
  update();
  tools.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{resize.disconnect();mutation.disconnect();window.removeEventListener('resize',update);cancelAnimationFrame(frame);});
}
setupStormFloatingTools();
document.addEventListener('shopify:section:load',setupStormFloatingTools);

// Only section headings entering from below move; the page and product images never scale.
function setupStormSectionMotion(scope = document) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{
    if (!entry.isIntersecting) return;
    observer.unobserve(entry.target);
    entry.target.animate([{opacity:.35,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'cubic-bezier(.2,.6,.3,1)'});
  }),{threshold:.3});
  scope.querySelectorAll('.sv-retail-row__head,.storm-section__head,.sv-ruled-heading,.sv-collection-cover__heading').forEach(el=>{
    if (el.dataset.motionReady) return;
    el.dataset.motionReady = 'true';
    if (el.getBoundingClientRect().top >= innerHeight) observer.observe(el);
  });
}
setupStormSectionMotion();
document.addEventListener('shopify:section:load',event=>setupStormSectionMotion(event.target));

;
/* Source: storm-hero-carousel.js */
if (!customElements.get('storm-hero-carousel')) {
  customElements.define('storm-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-hero-track]');
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.tabs = [...this.querySelectorAll('[data-hero-tab]')];
      this.panels = [...this.querySelectorAll('[data-hero-panel]')];
      this.stage = this.closest('.shopify-section');
      this.activePanel = 0;
      const selectTab = i => {
        this.activePanel = i;
        this.tabs.forEach((tab, n) => { tab.setAttribute('aria-selected', String(n === i)); tab.tabIndex = n === i ? 0 : -1; });
        this.panels.forEach((panel, n) => panel.hidden = n !== i);
        if (i === 0) this.go(this.index); else this.schedule();
      };
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => selectTab(i), options);
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault(); event.stopPropagation();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length-1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          selectTab(next); this.tabs[next].focus();
        }, options);
      });
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.track || !this.slides.length) return;
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true), options));
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, options);
      this.track.addEventListener('scroll', () => {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index !== this.index) { this.index = index; this.update(); }
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.indexOf(event.target.closest('[data-hero-slide]'));
        if (i >= 0) this.go(i, true);
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.resize = new ResizeObserver(() => this.go(this.index));
      this.resize.observe(this.track);
      this.update(); this.schedule();
    }
    go(index, manual = false) {
      const previous = this.index;
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      if (previous !== this.index && !this.paused) {
        this.dispatchEvent(new CustomEvent('storm:hero-change',{bubbles:true,detail:{slide:this.slides[this.index]}}));
      }
      this.update(); this.schedule();
    }
    update() {
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      const palette = {navy:'#becbda',collagen:'#efd2de',aura:'#efddba',omega:'#b8d5d8',probexa:'#ddd0e7',citrus:'#f5dfa8'};
      this.stage?.style.setProperty('--sv-stage-color', palette[this.slides[this.index]?.dataset.palette] || palette.navy);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length > 1 && this.activePanel === 0 && !this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1), 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.resize?.disconnect(); }
  });
}

;
/* Source: storm-retail.js */
const stormFavoriteKey = 'storm-vitals-favorites';
let stormFavorites = new Set();
const stormRetailMatches = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
try { const saved = JSON.parse(window.StormPrivacy.storage('local').getItem(stormFavoriteKey) || '[]'); if (Array.isArray(saved)) stormFavorites = new Set(saved.filter(v => typeof v === 'string').slice(0,200)); } catch {}
function syncStormFavorites(scope = document) {
  stormRetailMatches(scope,'[data-storm-favorite]').forEach(button => button.setAttribute('aria-pressed', String(stormFavorites.has(button.dataset.stormFavorite))));
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-storm-favorite]');
  if (!button) return;
  event.preventDefault();
  const handle = button.dataset.stormFavorite;
  if (stormFavorites.has(handle)) stormFavorites.delete(handle); else if (stormFavorites.size < 200) stormFavorites.add(handle);
  try { window.StormPrivacy.storage('local').setItem(stormFavoriteKey, JSON.stringify([...stormFavorites])); } catch {}
  syncStormFavorites();
});
window.addEventListener('storage', event => {
  if (event.key !== stormFavoriteKey) return;
  try { const values = JSON.parse(event.newValue || '[]'); stormFavorites = new Set(Array.isArray(values) ? values.filter(v=>typeof v==='string').slice(0,200) : []); } catch { stormFavorites = new Set(); }
  syncStormFavorites();
});
// Initialize only inserted store components, instead of rescanning the entire
// catalogue whenever a spinner, recommendation or story clone changes the DOM.
const stormRetailPending = new Set();
let stormRetailFrame;
new MutationObserver(records => {
  const selector='[data-storm-favorite],[data-retail-slides],[data-retail-carousel],[data-retail-menu],.sv-uniform-card';
  for (const record of records) for (const node of record.addedNodes) {
    if (node.nodeType===1 && (node.matches(selector)||node.querySelector(selector))) stormRetailPending.add(node);
  }
  if (!stormRetailPending.size || stormRetailFrame) return;
  stormRetailFrame=requestAnimationFrame(()=>{
    stormRetailFrame=0;
    const roots=[...stormRetailPending].filter(node=>node.isConnected);
    stormRetailPending.clear();
    roots.filter(node=>!roots.some(parent=>parent!==node&&parent.contains(node))).forEach(setupStormRetail);
  });
}).observe(document.body,{childList:true,subtree:true});

const stormTitleRecords = new WeakMap();
const stormTitleVisibility = new IntersectionObserver(entries=>entries.forEach(entry=>{
  entry.target.toggleAttribute('data-title-visible',entry.isIntersecting);
}),{threshold:.1});
const stormTitleResize = new ResizeObserver(entries=>entries.forEach(entry=>measureStormCardTitle(entry.target)));
function measureStormCardTitle(link) {
  const record=stormTitleRecords.get(link);if(!record||!link.clientWidth)return;
  const width=record.original.getBoundingClientRect().width;
  const overflow=width>link.clientWidth+2;
  link.toggleAttribute('data-title-overflow',overflow);
  if(overflow){
    if(!record.copy){record.copy=record.original.cloneNode(true);record.copy.setAttribute('aria-hidden','true');record.track.append(record.copy);}
    const distance=width+(parseFloat(getComputedStyle(record.track).columnGap)||20);
    link.style.setProperty('--sv-title-shift',(-distance)+'px');
    link.style.setProperty('--sv-title-duration',Math.max(10,distance/25)+'s');
  }else{record.copy?.remove();record.copy=null;}
}
function setupStormCardTitles(scope=document) {
  const cards=stormRetailMatches(scope,'.sv-uniform-card');
  cards.forEach(card=>card.querySelectorAll('.card > .card__content .card__heading a').forEach(link=>{
    if(!stormTitleRecords.has(link)){
      const text=link.textContent.trim();if(!text)return;
      const track=document.createElement('span');track.className='sv-card-title-track';
      const original=document.createElement('span');original.textContent=text;track.append(original);link.replaceChildren(track);
      stormTitleRecords.set(link,{track,original,copy:null});stormTitleVisibility.observe(link);stormTitleResize.observe(link);
    }
    measureStormCardTitle(link);
  }));
}
document.fonts?.ready.then(()=>setupStormCardTitles());
function setupStormRetail(scope = document) {
  syncStormFavorites(scope);
  setupStormCardTitles(scope);
  setupStormCategoryStrip(scope);
  stormRetailMatches(scope,'[data-retail-slides]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-retail-slide]')];
    const dots = [...root.querySelectorAll('[data-retail-slide-dot]')];
    let selected = 0;
    const select = index => {
      selected = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => { slide.hidden = position !== selected; });
      dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === selected)));
    };
    root.querySelector('[data-retail-slide-prev]')?.addEventListener('click', () => select(selected - 1));
    root.querySelector('[data-retail-slide-next]')?.addEventListener('click', () => select(selected + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => select(index)));
    root.addEventListener('shopify:block:select', event => {
      const index = slides.indexOf(event.target.closest('[data-retail-slide]'));
      if (index >= 0) select(index);
    });
  });
  stormRetailMatches(scope,'[data-retail-carousel]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('[data-retail-track]');
    const previous = root.querySelector('[data-retail-prev]');
    const next = root.querySelector('[data-retail-next]');
    const dots = document.createElement('div');
    dots.className = 'sv-retail-page-dots';
    root.append(dots);
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const pages = max < 4 ? 1 : Math.ceil(max / track.clientWidth) + 1;
      if (dots.children.length !== pages) {
        dots.replaceChildren();
        for (let i=0;i<pages;i++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `${root.closest('section')?.querySelector('h2')?.textContent || ''} · ${i+1}`);
          button.addEventListener('click', () => track.scrollTo({left: (i===pages-1?track.scrollWidth-track.clientWidth:i*track.clientWidth)*(document.dir==='rtl'?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
          dots.append(button);
        }
      }
      const selected = Math.abs(track.scrollLeft)>=max-2 ? pages-1 : Math.round(Math.abs(track.scrollLeft)/track.clientWidth);
      [...dots.children].forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)));
      dots.hidden = pages===1;
      previous.disabled = Math.abs(track.scrollLeft) < 2;
      next.disabled = Math.abs(track.scrollLeft) >= max - 2;
      previous.hidden = next.hidden = max < 4;
    };
    const step = direction => track.scrollBy({left: direction * track.clientWidth * (document.dir === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    let scrollFrame;
    track.addEventListener('scroll', () => { if (!scrollFrame) scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;update();}); }, {passive:true});
    new ResizeObserver(update).observe(track);
    const promo=root.closest('.sv-featured-with-promo')?.querySelector('.sv-pinned-bundle');
    const promoSibling=track.querySelector('.card');
    if(promo&&promoSibling){
      const syncPromoHeight=()=>promo.style.setProperty('--sv-promo-height',promoSibling.getBoundingClientRect().height+'px');
      new ResizeObserver(syncPromoHeight).observe(promoSibling);syncPromoHeight();
    }
    let autoplayTimer;
    let touching = false;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const autoplay = () => {
      clearTimeout(autoplayTimer);
      if (!root.isConnected) return;
      autoplayTimer = setTimeout(() => {
        const rect = root.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < innerHeight;
        const max = track.scrollWidth - track.clientWidth;
        if (!motion.matches && !document.hidden && visible && !touching && !root.matches(':hover') && !root.contains(document.activeElement) && max > 4) {
          const direction = document.dir === 'rtl' ? -1 : 1;
          const atEnd = Math.abs(track.scrollLeft) >= max - 2;
          track.scrollTo({left: atEnd ? 0 : direction * Math.min(max, Math.abs(track.scrollLeft) + track.clientWidth), behavior:'smooth'});
        }
        autoplay();
      }, 5500);
    };
    root.addEventListener('pointerdown', () => { touching = true; });
    const release = () => { touching = false; autoplay(); };
    root.addEventListener('pointerup', release);
    root.addEventListener('pointercancel', release);
    root.addEventListener('pointerleave', release);
    root.addEventListener('click', autoplay);
    autoplay();
    update();
  });
  stormRetailMatches(scope,'[data-retail-menu]').forEach(menu => {
    if (menu.dataset.initialized) return;
    menu.dataset.initialized = 'true';
    const item = menu.closest('.sv-retail-nav__item');
    const summary = menu.querySelector('summary');
    let closeTimer;
    const open = () => {
      clearTimeout(closeTimer);
      document.querySelectorAll('[data-retail-menu]').forEach(other => { if (other !== menu) other.open = false; });
      menu.open = true;
    };
    item.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'touch' && matchMedia('(min-width: 990px)').matches) open();
    });
    item.addEventListener('pointerleave', () => {
      closeTimer = setTimeout(() => { if (!item.contains(document.activeElement)) menu.open = false; }, 150);
    });
    item.addEventListener('focusout', event => {
      if (!item.contains(event.relatedTarget)) menu.open = false;
    });
    menu.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(menu.open));
      if (menu.open) document.querySelectorAll('[data-retail-menu]').forEach(other => { if (other !== menu) other.open = false; });
    });
    summary.setAttribute('aria-expanded', String(menu.open));
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  });
}
function setupStormCategoryStrip(scope=document) {
  stormRetailMatches(scope,'.sv-shop-categories').forEach(track=>{
    if(track.dataset.categoryReady)return;
    track.dataset.categoryReady='true';
    const abort=new AbortController(),options={signal:abort.signal};
    const originals=[...track.children];
    const copies=originals.map(item=>{const copy=item.cloneNode(true);copy.dataset.categoryClone='true';copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);return copy;});
    track.append(...copies);
    const mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
    let cycle=0,position=track.scrollLeft,frame=0,last=0,visible=false,touching=false,pausedUntil=0;
    const measure=()=>{cycle=copies[0]?.offsetLeft-originals[0]?.offsetLeft;position=track.scrollLeft;};
    const tick=time=>{
      frame=0;
      const elapsed=last?Math.min(time-last,50):0;last=time;
      if(mobile.matches&&!reduced.matches&&!document.hidden&&visible&&cycle>0&&!touching&&time>pausedUntil&&!track.contains(document.activeElement)){
        position+=elapsed*.02;
        if(position>=cycle)position-=cycle;
        track.scrollLeft=position;
      }else position=track.scrollLeft;
      if(visible&&!document.hidden&&mobile.matches&&!reduced.matches)frame=requestAnimationFrame(tick);
    };
    const start=()=>{cancelAnimationFrame(frame);last=0;track.toggleAttribute('data-category-autoplay',mobile.matches&&!reduced.matches);measure();if(visible&&!document.hidden&&mobile.matches&&!reduced.matches)frame=requestAnimationFrame(tick);};
    const hold=()=>{pausedUntil=performance.now()+5000;position=track.scrollLeft;};
    track.addEventListener('pointerdown',()=>{touching=true;hold();},options);
    const release=()=>{touching=false;hold();};
    window.addEventListener('pointerup',release,options);window.addEventListener('pointercancel',release,options);
    track.addEventListener('wheel',hold,{...options,passive:true});track.addEventListener('focusin',hold,options);
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;start();},{threshold:.05});observer.observe(track);
    const resize=new ResizeObserver(measure);resize.observe(track);
    document.addEventListener('visibilitychange',start,options);mobile.addEventListener('change',start,options);reduced.addEventListener('change',start,options);
    track.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{abort.abort();cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();},{once:true});
  });
}
setupStormRetail();
document.addEventListener('shopify:section:load', event => setupStormRetail(event.target));
document.addEventListener('click', event => { if (!event.target.closest('[data-retail-menu]')) document.querySelectorAll('[data-retail-menu][open]').forEach(menu => { menu.open = false; }); });

document.addEventListener('storm:privacy', () => {
  try { stormFavorites = new Set(JSON.parse(window.StormPrivacy.storage('local').getItem(stormFavoriteKey) || '[]')); } catch { stormFavorites = new Set(); }
  syncStormFavorites();
});

;
/* Source: storm-storefront.js */
function setupStormStorefront(scope = document) {
  const header = document.querySelector('.header');
  if (header && !header.dataset.stormMeasured) {
    header.dataset.stormMeasured = 'true';
    const measure = () => document.documentElement.style.setProperty('--storm-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    measure();
    new ResizeObserver(measure).observe(header);
  }
  scope.querySelectorAll('[data-storm-guide-target]').forEach(link => {
    if (link.dataset.stormBound) return;
    link.dataset.stormBound = 'true';
    link.addEventListener('click', event => {
      const target = document.querySelector(`.sv-product-tabs a[href^="#Product${link.dataset.stormGuideTarget}-"]`);
      if (!target) return;
      event.preventDefault();
      target.click();
      document.getElementById('StormProductDetails').scrollIntoView({block:'start'});
      target.focus({preventScroll:true});
    });
  });
}
setupStormStorefront();
document.addEventListener('shopify:section:load', event => setupStormStorefront(event.target));

;
/* Source: storm-commerce.js */
function setupStormCommerce(scope = document) {
  scope.querySelectorAll('.sv-product-guide').forEach(guide => {
    const nav = guide.querySelector('.sv-product-tabs');
    if (!nav || nav.dataset.enhanced) return;
    const tabs = [...nav.querySelectorAll('a[href^="#"]')];
    const panels = tabs.map(tab => document.getElementById(tab.hash.slice(1)));
    if (panels.some(panel => !panel)) return;
    nav.dataset.enhanced = 'true';
    nav.setAttribute('role', 'tablist');
    function select(index, focus = false) {
      tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[position].hidden = !active;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, index) => {
      tab.id = `${panels[index].id}-tab`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].tabIndex = 0;
      panels[index].setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', event => {
        event.preventDefault();
        select(index);
        history.replaceState(null, '', tab.hash);
      });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
    const initial = tabs.findIndex(tab => tab.hash === location.hash);
    select(initial < 0 ? 0 : initial);
    window.addEventListener('hashchange', () => {
      const index = tabs.findIndex(tab => tab.hash === location.hash);
      if (index >= 0) select(index);
    });
  });
  scope.querySelectorAll('[data-storm-recent]').forEach(section => {
    if (section.dataset.initialized || !window.StormPrivacy?.allowed('preferences')) return;
    section.dataset.initialized = 'true';
    const key = 'storm-viewed-products-v1';
    let records;
    let current;
    try {
      records = JSON.parse(window.StormPrivacy.storage('session').getItem(key) || '[]');
      if (!Array.isArray(records)) records = [];
      records = records.filter(handle => typeof handle === 'string' && /^[a-z0-9-]{1,200}$/.test(handle));
      const metadata = document.querySelector('[data-storm-viewed-product]');
      current = metadata ? JSON.parse(metadata.textContent).handle : null;
      if (current) window.StormPrivacy.storage('session').setItem(key, JSON.stringify([current, ...records.filter(handle => handle !== current)].slice(0, 12)));
    } catch { return; }
    const history = records.filter(handle => handle !== current).slice(0, 10);
    if (!history.length) return;
    const controller = new AbortController();
    const root = section.dataset.root || '/';
    const results = section.querySelector('[data-storm-recent-items]');
    let cancelled = false;
    section.querySelector('[data-storm-recent-clear]').addEventListener('click', () => {
      cancelled = true;
      controller.abort();
      try { window.StormPrivacy.storage('session').removeItem(key); } catch {}
      results.replaceChildren();
      section.hidden = true;
    });
    async function load() {
      const cards = await Promise.all(history.map(async handle => {
        try {
          const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=storm-recent-card`, {signal:controller.signal});
          if (!response.ok) return null;
          return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-storm-recent-card]');
        } catch { return null; }
      }));
      if (cancelled || !window.StormPrivacy?.allowed('preferences')) return;
      const valid = cards.filter(Boolean);
      results.replaceChildren(...valid);
      section.hidden = !valid.length;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
    }, {rootMargin:'500px'});
    observer.observe(section.closest('.shopify-section') || section.parentElement);
  });
}
setupStormCommerce();
document.addEventListener('shopify:section:load', event => setupStormCommerce(event.target));

document.addEventListener('storm:privacy', () => {
  document.querySelectorAll('[data-storm-recent]').forEach(section => {
    if (!window.StormPrivacy.allowed('preferences')) { section.hidden = true; section.querySelector('[data-storm-recent-items]')?.replaceChildren(); delete section.dataset.initialized; }
  });
  if (window.StormPrivacy.allowed('preferences')) setupStormCommerce();
});

;
/* Source: storm-motion.js */
/*! Storm motion controller — Motion 14.4.0. Source: shopify/motion/src/storm-motion.js
The MIT License (MIT)

Copyright (c) 2024 [Motion](https://motion.dev) B.V.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/
"use strict";(()=>{var v=()=>{};var O={};function R(t){let e;return()=>(e===void 0&&(e=t()),e)}var k=t=>t;var h=t=>t*1e3,T=t=>t/1e3;var F=t=>Array.isArray(t)&&typeof t[0]=="number";var g={delta:0,timestamp:0,isProcessing:!1};var A;function ge(){A=void 0}var L={now:()=>(A===void 0&&L.set(g.isProcessing||O.useManualTiming?g.timestamp:performance.now()),A),set:t=>{A=t,queueMicrotask(ge)}};var Q=(t,e,o=10)=>{let r="",n=Math.max(Math.round(e/o),2);for(let m=0;m<n;m++)r+=Math.round(t(m/(n-1))*1e4)/1e4+", ";return`linear(${r.substring(0,r.length-2)})`};var ye=t=>t!==null;function ee(t,{repeat:e,repeatType:o="loop"},r,n=1){let m=t.filter(ye),c=n<0||e&&o!=="loop"&&e%2===1?0:m.length-1;return!c||r===void 0?m[c]:r}function ve(t,e){return{kind:t,animation:e,timestamp:L.now(),frameTimestamp:g.timestamp,frameIsProcessing:g.isProcessing}}function te(t,e,o){let r=globalThis.__MOTION_INSPECT__;if(r)try{r({...ve("animation-start",t),options:o?{...e,...o}:e})}catch{}}var M=class{constructor(){this.isResolved=!1}get finished(){return this._finished||(this._finished=this.isResolved?Promise.resolve():new Promise(e=>{this._resolve=e})),this._finished}updateFinished(){this._finished=this._resolve=void 0,this.isResolved=!1}notifyFinished(){this.isResolved=!0,this._resolve?.()}then(e,o){return this.finished.then(e,o)}};function N(t){for(let e=1;e<t.length;e++)t[e]??(t[e]=t[e-1])}var P=t=>t.startsWith("--");function oe(t,e,o){P(e)?t.style.setProperty(e,o):t.style[e]=o}var re={};function D(t,e){let o=R(t);return()=>re[e]??o()}var ie=D(()=>window.ScrollTimeline!==void 0,"scrollTimeline");var w=D(()=>{try{document.createElement("div").animate({opacity:0},{easing:"linear(0, 1)"})}catch{return!1}return!0},"linearEasing");var x=([t,e,o,r])=>`cubic-bezier(${t}, ${e}, ${o}, ${r})`;var W={linear:"linear",ease:"ease",easeIn:"ease-in",easeOut:"ease-out",easeInOut:"ease-in-out",circIn:x([0,.65,.55,1]),circOut:x([.55,0,1,.45]),backIn:x([.31,.01,.66,-.59]),backOut:x([.33,1.53,.69,.99])};function G(t,e){if(t)return typeof t=="function"?w()?Q(t,e):"ease-out":F(t)?x(t):Array.isArray(t)?t.map(o=>G(o,e)||W.easeOut):W[t]}function ne(t,e,o,{delay:r=0,duration:n=300,repeat:m=0,repeatType:l="loop",ease:c="easeOut",times:s}={},a=void 0){let i={[e]:o};s&&(i.offset=s);let p=G(c,n);Array.isArray(p)&&(i.easing=p);let f={delay:r,duration:n,easing:Array.isArray(p)?"linear":p,fill:"both",iterations:m+1,direction:l==="reverse"?"alternate":"normal"};return a&&(f.pseudoElement=a),t.animate(i,f)}function ae(t){return typeof t=="function"&&"applyToOptions"in t}function se({type:t,...e}){return ae(t)&&w()?t.applyToOptions(e):(e.duration??(e.duration=300),e.ease??(e.ease="easeOut"),e)}var S=class extends M{constructor(e){if(super(),this.finishedTime=null,this.isStopped=!1,this.manualStartTime=null,!e)return;let{element:o,name:r,keyframes:n,pseudoElement:m,allowFlatten:l=!1,finalKeyframe:c,onComplete:s}=e;this.isPseudoElement=!!m,this.allowFlatten=l,this.options=e,v(typeof e.type!="string",`Mini animate() doesn't support "type" as a string.`,"mini-spring");let a=se(e);this.animation=ne(o,r,n,a,m),a.autoplay===!1&&this.animation.pause(),this.animation.onfinish=()=>{if(this.finishedTime=this.time,!m){let i=ee(n,this.options,c,this.speed);this.updateMotionValue&&this.updateMotionValue(i),oe(o,r,i),this.animation.cancel()}s?.(),this.notifyFinished()},te(this,e,a)}play(){this.isStopped||(this.manualStartTime=null,this.animation.play(),this.state==="finished"&&this.updateFinished())}pause(){this.animation.pause()}complete(){this.animation.finish?.()}cancel(){try{this.animation.cancel()}catch{}}stop(){if(this.isStopped)return;this.isStopped=!0;let{state:e}=this;e==="idle"||e==="finished"||(this.updateMotionValue?this.updateMotionValue():this.commitStyles(),this.isPseudoElement||this.cancel())}commitStyles(){let e=this.options?.element;!this.isPseudoElement&&e?.isConnected&&this.animation.commitStyles?.()}get duration(){let e=this.animation.effect?.getComputedTiming?.().duration||0;return T(Number(e))}get iterationDuration(){let{delay:e=0}=this.options||{};return this.duration+T(e)}get time(){return T(Number(this.animation.currentTime)||0)}set time(e){let o=this.finishedTime!==null;this.manualStartTime=null,this.finishedTime=null,this.animation.currentTime=h(e),o&&this.animation.pause()}get speed(){return this.animation.playbackRate}set speed(e){e<0&&(this.finishedTime=null),this.animation.playbackRate=e}get state(){return this.finishedTime!==null?"finished":this.animation.playState}get startTime(){return this.manualStartTime??Number(this.animation.startTime)}set startTime(e){this.manualStartTime=this.animation.startTime=e}attachTimeline({timeline:e,onAttach:o,observe:r}){return this.allowFlatten&&this.animation.effect?.updateTiming({easing:"linear"}),this.animation.onfinish=null,e&&ie()?(this.animation.timeline=e,o?.(this.animation),k):r(this)}};var B=class{constructor(e){this.stop=()=>this.runAll("stop"),this.animations=e.filter(Boolean)}get finished(){return Promise.all(this.animations.map(e=>e.finished))}getAll(e){return this.animations[0][e]}setAll(e,o){for(let r=0;r<this.animations.length;r++)this.animations[r][e]=o}attachTimeline(e){let o=this.animations.map(r=>r.attachTimeline(e));return()=>{o.forEach((r,n)=>{r&&r(),this.animations[n].stop()})}}get time(){return this.getAll("time")}set time(e){this.setAll("time",e)}get speed(){return this.getAll("speed")}set speed(e){this.setAll("speed",e)}get state(){return this.getAll("state")}get startTime(){return this.getAll("startTime")}get duration(){return me(this.animations,"duration")}get iterationDuration(){return me(this.animations,"iterationDuration")}runAll(e){this.animations.forEach(o=>o[e]())}play(){this.runAll("play")}pause(){this.runAll("pause")}cancel(){this.runAll("cancel")}complete(){this.runAll("complete")}};function me(t,e){let o=0;for(let r=0;r<t.length;r++){let n=t[r][e];n!==null&&n>o&&(o=n)}return o}var V=class extends B{then(e,o){return this.finished.finally(e).then(()=>{})}};var pe=new WeakMap,K=(t,e="")=>`${t}:${e}`;function z(t){let e=pe.get(t);return e||(e=new Map,pe.set(t,e)),e}function fe(t,e){if(t?.inherit&&e){let{inherit:o,...r}=t;return{...e,...r}}return t}function j(t,e){let o=t?.[e]??t?.default??t;return o!==t?fe(o,t):o}var le=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"];var ce=new Set(["borderWidth","borderTopWidth","borderRightWidth","borderBottomWidth","borderLeftWidth","borderRadius",...le,"width","maxWidth","height","maxHeight","top","right","bottom","left","inset","insetBlock","insetBlockStart","insetBlockEnd","insetInline","insetInlineStart","insetInlineEnd","padding","paddingTop","paddingRight","paddingBottom","paddingLeft","paddingBlock","paddingBlockStart","paddingBlockEnd","paddingInline","paddingInlineStart","paddingInlineEnd","margin","marginTop","marginRight","marginBottom","marginLeft","marginBlock","marginBlockStart","marginBlockEnd","marginInline","marginInlineStart","marginInlineEnd","fontSize","backgroundPositionX","backgroundPositionY"]);function q(t,e){for(let o=0;o<t.length;o++)typeof t[o]=="number"&&ce.has(e)&&(t[o]=t[o]+"px")}function E(t,e,o){if(t==null)return[];if(t instanceof EventTarget)return[t];if(typeof t=="string"){let r=document;e&&(r=e.current);let n=o?.[t]??r.querySelectorAll(t);return n?Array.from(n):[]}return Array.from(t).filter(r=>r!=null)}function C(t,e){let o=window.getComputedStyle(t);return P(e)?o.getPropertyValue(e):o[e]}function ue(t,e,o,r){if(t==null)return[];let n=E(t,r),m=n.length;v(!!m,"No valid elements provided.","no-valid-elements");let l=[];for(let s=0;s<m;s++){let a=n[s],i={...o};typeof i.delay=="function"&&(i.delay=i.delay(s,m));for(let p in e){let f=e[p];Array.isArray(f)||(f=[f]);let u={...j(i,p)};u.duration&&(u.duration=h(u.duration)),u.delay&&(u.delay=h(u.delay));let J=z(a),X=K(p,u.pseudoElement||""),Y=J.get(X);Y&&Y.stop(),l.push({map:J,key:X,unresolvedKeyframes:f,options:{...u,element:a,name:p,allowFlatten:!i.type&&!i.ease}})}}for(let s=0;s<l.length;s++){let{unresolvedKeyframes:a,options:i}=l[s],{element:p,name:f,pseudoElement:u}=i;!u&&a[0]===null&&(a[0]=C(p,f)),N(a),q(a,f),!u&&a.length<2&&a.unshift(C(p,f)),i.keyframes=a}let c=[];for(let s=0;s<l.length;s++){let{map:a,key:i,options:p}=l[s],f=new S(p);a.set(i,f),f.finished.finally(()=>a.delete(i)),c.push(f)}return c}var Te=t=>{function e(o,r,n){return new V(ue(o,r,n,t))}return e},I=Te();var Se={some:0,all:1};function H(t,e,{root:o,margin:r,amount:n="some"}={}){let m=E(t),l=new WeakMap,c=a=>{a.forEach(i=>{let p=l.get(i.target);if(i.isIntersecting!==!!p)if(i.isIntersecting){let f=e(i.target,i);typeof f=="function"?l.set(i.target,f):s.unobserve(i.target)}else typeof p=="function"&&(p(i),l.delete(i.target))})},s=new IntersectionObserver(c,{root:o,rootMargin:r,threshold:typeof n=="number"?n:Se[n]});return m.forEach(a=>s.observe(a)),()=>s.disconnect()}var b=matchMedia("(prefers-reduced-motion: reduce)"),_=".sv-uniform-card,.sv-shop-category,.sv-bundle__product,.sv-nature__tile,.sv-trust-strip article,.sv-formula-fact,.sv-use-card,.sv-label-guide article,.sv-footer-news__intro,.sv-store-footer__contact,.sv-collection-cover__copy,.sv-company__chapter,.sv-company__split,.sv-company__facts,.sv-hero-benefits > a,.sv-advantage-packs__head,.sv-featured__heading",de=new WeakSet,y=new Map,d=new Map;document.addEventListener("storm:hero-change",t=>{let e=t.detail?.slide;if(!e||b.matches||document.hidden)return;d.get(e)?.complete();let o=I(e,{opacity:[.35,1]},{duration:.65,ease:[.22,.61,.36,1]});d.set(e,o),o.then(()=>{d.get(e)===o&&(d.delete(e),e.style.removeProperty("opacity"))})});function Ve(t){if(y.delete(t),t.dataset.stormMotion="done",b.matches||document.hidden||!t.isConnected){t.style.removeProperty("opacity");return}let e=I(t,{opacity:[.82,1]},{duration:.55,ease:[.22,.61,.36,1]});d.set(t,e),e.then(()=>{d.get(t)===e&&(d.delete(t),t.style.removeProperty("opacity"))})}function Z(t=document){[...t.matches?.(_)?[t]:[],...t.querySelectorAll(_)].forEach(o=>{de.has(o)||(de.add(o),o.dataset.stormMotion="done",!(b.matches||o.getBoundingClientRect().top<innerHeight)&&(o.style.opacity=".82",o.dataset.stormMotion="ready",y.set(o,H(o,Ve,{amount:.05}))))})}function xe(){for(let[t,e]of y)e(),t.dataset.stormMotion="done",t.style.removeProperty("opacity");y.clear();for(let[t,e]of d)e.complete(),t.style.removeProperty("opacity");d.clear()}function he(){for(let[t,e]of y)t.isConnected||(e(),y.delete(t));for(let[t,e]of d)t.isConnected||(e.stop(),d.delete(t))}b.addEventListener("change",()=>{b.matches&&xe()});document.addEventListener("visibilitychange",()=>{document.hidden&&xe()});document.addEventListener("shopify:section:load",t=>Z(t.target));document.addEventListener("shopify:section:unload",he);var $=!1,U=new Set;new MutationObserver(t=>{t.forEach(e=>e.addedNodes.forEach(o=>{o.nodeType===1&&(o.matches(_)||o.querySelector(_))&&U.add(o)})),!$&&($=!0,requestAnimationFrame(()=>{$=!1,he();let e=[...U].filter(o=>o.isConnected);U.clear(),e.filter(o=>!e.some(r=>r!==o&&r.contains(o))).forEach(Z)}))}).observe(document.body,{childList:!0,subtree:!0});Z();})();

;
/* Source: storm-sales-engine.js */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;if(root)root.StormSalesMath=api;})(typeof window==='object'?window:null,function(){
  function campaignTotal(lines){
    const sorted=lines.filter(x=>x.price>0&&x.quantity>0).map(x=>({price:Math.round(x.price),quantity:Math.floor(x.quantity)})).sort((a,b)=>a.price-b.price);
    const count=sorted.reduce((n,x)=>n+x.quantity,0);let free=Math.floor(count/3),saving=0;
    for(const x of sorted){const n=Math.min(free,x.quantity);saving+=n*x.price;free-=n;}
    return {count,saving,total:sorted.reduce((n,x)=>n+x.price*x.quantity,0)-saving};
  }
  function quote(cart,candidate,eligibleIds,campaign=true){
    const lines=(cart.items||[]).map(x=>({price:x.original_price??x.price,quantity:x.quantity}));
    const allEligible=(cart.items||[]).every(x=>eligibleIds.has(String(x.variant_id??x.id))&&!x.selling_plan_allocation);
    if(!campaign||!allEligible||candidate.price<=0)return null;
    const before=campaignTotal(lines);
    if(Math.abs(before.total-cart.total_price)>1)return null;
    const after=campaignTotal([...lines,{price:candidate.price,quantity:1}]);
    return {delta:after.total-before.total,total:after.total,saving:after.saving,count:after.count};
  }
  function shippingRemaining(total,threshold){return Math.max(0,Math.round(threshold)-Math.round(total));}
  function unitPrice(price,units){return units>0?price/units:null;}
  return {campaignTotal,quote,shippingRemaining,unitPrice};
});

;
/* Source: storm-recommendation-engine.js */
/* Pure, deterministic ranking shared by product shelves and cart offers. */
(function(scope){
  const text=value=>String(value||'').toLocaleLowerCase('tr').normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  const words=p=>new Set(text([p.title,...(p.tags||[])].join(' ')).split(/[^a-z0-9ı]+/).filter(w=>w.length>2&&!/^(storm|vitals|tablet|kapsul|softjel|complex|\d+)$/.test(w)));
  const child=p=>/kids|cocuk|junior|baby|bebek/.test(text(p.title+' '+(p.tags||[]).join(' ')));
  function available(p){
    if(p.giftCard||p.available===false)return null;
    const v=(p.variants||[]).find(v=>v.available&&v.price>0&&(v.min||1)<=1&&(v.step||1)===1&&(!v.max||v.max>=1));
    return v?{...p,...v,id:p.id,variant:v.id}:null;
  }
  function rank(catalogue,seeds,{intent='related',native=[],exclude=[],pairs={},limit=6}={}){
    const banned=new Set([...exclude,...seeds.map(p=>p.id)].map(String));
    const frequency=new Map();
    catalogue.forEach(p=>(p.collections||[]).forEach(c=>frequency.set(String(c),(frequency.get(String(c))||0)+1)));
    const results=[];
    for(const raw of catalogue){
      const p=available(raw);if(!p||banned.has(String(p.id)))continue;
      let best=0,reason='',evidence=0;
      for(const seed of seeds){
        if(child(seed)!==child(p))continue;
        const same=!!seed.family&&seed.family===p.family;
        if(intent==='complementary'&&same)continue;
        const a=words(seed),b=words(p),overlap=[...a].filter(w=>b.has(w)).length/Math.max(1,new Set([...a,...b]).size);
        const collections=(seed.collections||[]).filter(c=>(p.collections||[]).map(String).includes(String(c)));
        const affinity=collections.reduce((sum,c)=>sum+Math.max(0,1-(frequency.get(String(c))||0)/Math.max(1,catalogue.length)),0);
        const pair=pairs?.[String(seed.id)]?.[String(p.id)];
        const bought=Number(pair?.orders)>=3&&Number(pair?.lift)>1;
        const nativeIndex=native.map(String).indexOf(String(p.id));
        const nativeScore=nativeIndex<0?0:Math.max(12,28-nativeIndex);
        const priceFit=seed.price>0?Math.min(seed.price,p.price)/Math.max(seed.price,p.price):0;
        let score=(intent==='related'?(same?50:0)+overlap*35:overlap*8)+affinity*12+nativeScore;
        if(intent==='complementary'&&bought)score+=40+Math.min(15,Number(pair.lift)*3);
        if(score<=0)continue;
        score+=priceFit*3+(seed.type&&seed.type===p.type?2:0);
        if(score>best){best=score;evidence=bought?Number(pair.orders):0;reason=intent==='complementary'&&bought?'Birlikte tercih edildi':same?'Farklı ambalaj seçeneği':nativeScore?'Size önerilen':affinity>0?'Aynı koleksiyondan':'Benzer ürün';}
      }
      if(best>0)results.push({product:p,score:best,reason,evidence});
    }
    results.sort((a,b)=>b.score-a.score||String(a.product.id).localeCompare(String(b.product.id)));
    const families=new Set();
    return results.filter(({product})=>{const key=product.family||product.id;if(families.has(key))return false;families.add(key);return true;}).slice(0,limit);
  }
  const api={rank,available};
  if(typeof module!=='undefined')module.exports=api;
  else scope.StormRecommendations=api;
})(typeof window==='undefined'?globalThis:window);

;
/* Source: storm-sales.js */
(() => {
  const configNode=document.getElementById('StormSalesConfig');if(!configNode||!window.StormSalesMath)return;
  let config;try{config=JSON.parse(configNode.textContent);}catch{return;}
  const math=window.StormSalesMath,strings=config.strings,products=config.products||[],root=config.root||'/';
  const variants=new Map();products.forEach(product=>product.variants.forEach(variant=>variants.set(String(variant.id),{...product,...variant,variant:variant.id})));
  const eligible=new Set([...variants].filter(([,v])=>!v.giftCard&&v.price>0).map(([id])=>id));
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'tr',{style:'currency',currency:config.currency}).format(value/100);
  const phrase=(key,amount)=>String(strings[key]||'').replace('[amount]',money(amount));
  const node=(tag,text,cls)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(cls)el.className=cls;return el;};
  function track(name,data){try{if(window.StormPrivacy?.allowed('analytics')===true)Promise.resolve(window.Shopify.analytics?.publish('storm:'+name,data)).catch(()=>{});}catch{}}
  let cart=null,pending=null,requestId=0,mutating=false;
  async function refreshCart(force=false){
    if(pending&&!force)return pending;
    const id=++requestId;
    const task=fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(response=>{if(!response.ok)throw Error(strings.error);return response.json();}).then(result=>{
      if(id===requestId){cart=result;document.querySelectorAll('storm-cart-offers').forEach(el=>el.render(result));}return result;
    }).finally(()=>{if(pending===task)pending=null;});pending=task;return task;
  }
  function statusFor(button){const scope=button.closest('.sv-product-bundle,storm-cart-offers,storm-recommendations');return scope?.querySelector('[data-sales-status]');}
  async function add(items,button,offer){
    if(mutating)return;mutating=true;
    const status=statusFor(button),old=button.textContent;
    button.disabled=true;button.setAttribute('aria-busy','true');if(!button.querySelector('img'))button.textContent=strings.adding;
    if(status){status.hidden=false;status.textContent=strings.adding;}
    const drawer=document.querySelector('cart-drawer');
    const EventClass=window.StandardEvents?.CartLinesUpdateEvent;
    let deferred;
    try{
      if(EventClass){deferred=EventClass.createPromise();deferred.promise.catch(()=>{});button.dispatchEvent(new EventClass({action:'add',context:button.closest('storm-cart-offers')?'cart':'product',lines:items.map(x=>({merchandiseId:String(x.id),quantity:x.quantity})),promise:deferred.promise}));}
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:drawer?drawer.getSectionsToRender().map(s=>s.id):['cart-icon-bubble'],sections_url:location.pathname})});
      const result=await response.json();if(!response.ok||result.status)throw Error(result.description||result.message||strings.error);
      if(drawer&&result.sections?.['cart-drawer']){
        drawer.classList.remove('is-empty');drawer.setActiveElement(button.closest('cart-drawer')?document.getElementById('cart-icon-bubble'):button);drawer.renderContents(result);
      }else if(result.sections?.['cart-icon-bubble']){
        const html=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');const source=html.querySelector('.shopify-section');if(source)document.getElementById('cart-icon-bubble').innerHTML=source.innerHTML;
      }
      cart=null;const current=await refreshCart(true);
      if(deferred)deferred.resolve({cart:EventClass.createCartFromAjaxResponse(current)});
      track('offer_added',{offer,variant_ids:items.map(x=>String(x.id)),quantity:items.reduce((n,x)=>n+x.quantity,0),currency:config.currency,cart_value:current.total_price/100});
      if(status){status.hidden=false;status.textContent=strings.added;}
      if(location.pathname.replace(/\/$/,'')===config.cartUrl.replace(/\/$/,''))location.reload();
      else if(!drawer)location.assign(config.cartUrl);
    }catch(error){
      deferred?.reject(error);if(status){status.hidden=false;status.textContent=error.message||strings.error;}
      refreshCart(true).catch(()=>{});
    }finally{
      mutating=false;if(button.isConnected){button.disabled=false;button.removeAttribute('aria-busy');if(!button.querySelector('img'))button.textContent=old;}
    }
  }
  function image(product){const img=node('img');img.src=product.image;img.alt='';img.width=48;img.height=56;img.loading='lazy';return img;}
  function availableOne(p){const v=p.variants.find(v=>v.available&&v.price>0&&v.min<=1&&v.step===1);return v?{...p,...v,variant:v.id}:null;}
  const offers=products.filter(p=>!p.giftCard).map(availableOne).filter(Boolean);
  class CartOffers extends HTMLElement{
    connectedCallback(){
      if(!this.bound){this.bound=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-offer-variant]');if(button)add([{id:Number(button.dataset.offerVariant),quantity:1}],button,button.dataset.offerType);});}
      if(cart)this.render(cart);
      this.visibilityObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.visibilityObserver.disconnect();refreshCart().catch(()=>{});}},{threshold:.01});this.visibilityObserver.observe(this);
      // A hidden mount cannot intersect until the drawer opens; observe the drawer shell instead.
      if(this.closest('cart-drawer')){
        this.drawerObserver=new MutationObserver(()=>{if(this.closest('cart-drawer')?.classList.contains('active'))refreshCart().catch(()=>{});});
        this.drawerObserver.observe(this.closest('cart-drawer'),{attributes:true,attributeFilter:['class']});
      }else refreshCart().catch(()=>{});
    }
    disconnectedCallback(){this.visibilityObserver?.disconnect();this.drawerObserver?.disconnect();}
    render(current){
      if(!this.isConnected)return;
      this.replaceChildren();this.hidden=!current.item_count;if(this.hidden)return;
      const groups=current.items.map(item=>({price:item.original_price??item.price,quantity:item.quantity}));
      const expected=math.campaignTotal(groups),trusted=config.campaign&&current.items.every(x=>eligible.has(String(x.variant_id??x.id))&&!x.selling_plan_allocation)&&Math.abs(expected.total-current.total_price)<=1;
      const remaining=(3-current.item_count%3)%3;
      const heading=node('div',undefined,'sv-cart-offers__heading');heading.append(node('span',strings.offer_label));
      const campaignTitle=remaining===1?strings.choose_one:remaining===2?strings.choose_two:trusted&&expected.saving>0?strings.earned:strings.checkout;
      heading.append(node('h3',campaignTitle));this.append(heading);
      if(config.campaign){
        const progress=node('div',undefined,'sv-sales-progress');progress.setAttribute('role','progressbar');progress.setAttribute('aria-label',strings.bundle_progress);progress.setAttribute('aria-valuemin','0');progress.setAttribute('aria-valuemax','3');progress.setAttribute('aria-valuenow',String(current.item_count%3||3));progress.style.setProperty('--sv-sales-progress',((current.item_count%3||3)/3*100)+'%');this.append(progress);
        if(trusted&&expected.saving>0)this.append(node('p',phrase('saved',expected.saving),'sv-sales-saving'));
      }
      let shippingLeft=null;
      if(config.shipping.enabled&&config.currency===config.shipping.currency&&config.country===config.shipping.country){
        shippingLeft=math.shippingRemaining(current.total_price,config.shipping.threshold);
        const shipping=node('div',undefined,'sv-sales-shipping');shipping.append(node('p',shippingLeft?phrase('shipping_left',shippingLeft):strings.shipping_done));
        const bar=node('div',undefined,'sv-sales-progress');bar.setAttribute('role','progressbar');bar.setAttribute('aria-label',strings.shipping_progress);bar.setAttribute('aria-valuemin','0');bar.setAttribute('aria-valuemax',String(config.shipping.threshold));bar.setAttribute('aria-valuenow',String(Math.min(config.shipping.threshold,current.total_price)));bar.style.setProperty('--sv-sales-progress',Math.min(100,current.total_price/config.shipping.threshold*100)+'%');shipping.append(bar,node('small',strings.shipping_note));this.append(shipping);
      }
      if(config.campaign&&remaining||shippingLeft>0){
        if(!remaining&&shippingLeft>0)this.append(node('h4',strings.shipping_suggest));
        const ids=new Set(current.items.map(x=>Number(x.product_id))),currentProducts=products.filter(p=>ids.has(Number(p.id)));
        this.nativeSignals??=new Map();
        if(window.StormRecommendations?.native)currentProducts.slice(0,3).forEach(seed=>{
          if(this.nativeSignals.has(seed.id))return;
          this.nativeSignals.set(seed.id,[]);
          Promise.all(['complementary','related'].map(intent=>window.StormRecommendations.native(seed.id,intent))).then(signals=>{
            this.nativeSignals.set(seed.id,[...new Set(signals.flat())]);
            if(this.isConnected&&cart)this.render(cart);
          });
        });
        const native=currentProducts.flatMap(seed=>this.nativeSignals.get(seed.id)||[]);
        const recommendations=window.StormRecommendations?.rank(products,currentProducts,{intent:'complementary',native,exclude:[...ids],pairs:config.pairs,limit:products.length})||[];
        const relevance=new Map(recommendations.map(row=>[String(row.product.id),row.score]));
        const ranked=offers.filter(product=>!ids.has(Number(product.id))&&relevance.has(String(product.id))).map(product=>{
          const quote=math.quote(current,product,eligible,config.campaign);
          const related=currentProducts.reduce((n,p)=>n+(p.id===product.id?6:0)+(p.family&&p.family===product.family?4:0)+(p.vendor===product.vendor?1:0)+(p.collections||[]).filter(id=>(product.collections||[]).includes(id)).length,0);
          return {product,quote,related:relevance.get(String(product.id))||related};
        }).sort((a,b)=>{
          if(!remaining&&shippingLeft>0){const ar=a.quote&&a.quote.total>=config.shipping.threshold,br=b.quote&&b.quote.total>=config.shipping.threshold;if(ar!==br)return ar?-1:1;}
          return b.related-a.related||(a.quote?.delta??a.product.price)-(b.quote?.delta??b.product.price);
        });
        const list=node('div',undefined,'sv-cart-offers__list');
        ranked.slice(0,this.dataset.context==='drawer'?2:3).forEach(({product,quote})=>{
          const row=node('article',undefined,'sv-cart-offer');if(product.image)row.append(image(product));
          const info=node('div'),link=node('a',product.title);link.href=product.url;info.append(link);
          info.append(node('span',quote?(quote.delta===0?strings.no_extra:phrase('extra',quote.delta)):money(product.price),'sv-cart-offer__price'));
          if(quote)info.append(node('small',phrase('next_total',quote.total)));else info.append(node('small',strings.calculates));
          const button=node('button',strings.add);button.type='button';button.dataset.offerVariant=String(product.variant);button.dataset.offerType=remaining?'complete-trio':'shipping';button.setAttribute('aria-label',strings.add+' · '+product.title);row.append(info,button);list.append(row);
        });this.append(list);
        if(config.campaign&&remaining){const link=node('a',strings.complete+' ↗','sv-sales-link');link.href=root+'pages/3-al-2-ode';this.append(link);}
      }
      const status=node('p',undefined,'sv-sales-status');status.dataset.salesStatus='';status.setAttribute('role','status');status.hidden=true;this.append(status);
      const signature=current.items.map(x=>x.key+':'+x.quantity).join('|');
      if(this.lastSignature!==signature){this.lastSignature=signature;track('offer_viewed',{placement:this.dataset.context,item_count:current.item_count,currency:config.currency});}
    }
  }
  customElements.define('storm-cart-offers',CartOffers);
  class PackUpgrade extends HTMLElement{
    connectedCallback(){
      const product=products.find(p=>p.handle===this.dataset.productHandle);if(!product?.units)return;
      const current=availableOne(product),larger=products.filter(p=>p.family===product.family&&p.units>product.units).map(availableOne).filter(Boolean).sort((a,b)=>a.units-b.units)[0];
      if(!current||!larger||math.unitPrice(larger.price,larger.units)>=math.unitPrice(current.price,current.units))return;
      this.replaceChildren();this.className='sv-pack-upgrade';this.hidden=false;
      const saving=Math.floor((1-math.unitPrice(larger.price,larger.units)/math.unitPrice(current.price,current.units))*100);
      const copy=node('div',undefined,'sv-pack-upgrade__copy');
      copy.append(node('span',larger.units+' '+larger.unit,'sv-pack-upgrade__size'));
      copy.append(node('strong',strings.unit_saving.replace('[percent]',String(saving))));
      const detail=node('p',undefined,'sv-pack-upgrade__prices');
      detail.append(node('del',money(math.unitPrice(current.price,current.units))),node('b',money(math.unitPrice(larger.price,larger.units))+' / '+product.unit));
      copy.append(detail);
      const link=node('a',strings.upgrade_link+' ↗');link.href=larger.url;link.addEventListener('click',()=>track('pack_upgrade_clicked',{from_product:String(product.id),to_product:String(larger.id)}));
      const visual=image(larger);visual.className='sv-pack-upgrade__image';visual.alt='';
      this.append(visual,copy,link);
    }
  }
  customElements.define('storm-pack-upgrade',PackUpgrade);
  const presets=[
    {name:strings.preset_aura,handles:['aura-sunscreen-spf50','aura-ultra-hydrating-cream','aura-sun-stick-spf50']},
    {name:strings.preset_daily,handles:['aura-anti-dandruff-shampoo','aura-ultra-hydrating-cream','aura-sunscreen-spf50']},
    {name:strings.preset_same,handles:['storm-vitals-magnesium-b-complex-60-tablet','storm-vitals-magnesium-b-complex-60-tablet','storm-vitals-magnesium-b-complex-60-tablet']}
  ];
  function setupPresets(scope=document){scope.querySelectorAll('[data-bundle-presets]').forEach(mount=>{
    if(mount.dataset.ready)return;mount.dataset.ready='true';const list=node('div',undefined,'sv-bundle-presets__list');
    presets.forEach(preset=>{
      const items=preset.handles.map(handle=>products.find(p=>p.handle===handle)).map(p=>p&&availableOne(p));if(items.some(p=>!p))return;
      const total=items.reduce((sum,p)=>sum+p.price,0),gift=config.campaign?Math.min(...items.map(p=>p.price)):0;
      const card=node('article'),art=node('div',undefined,'sv-bundle-presets__art');items.forEach(p=>{if(p.image)art.append(image(p));});
      card.append(art,node('h3',preset.name),node('strong',strings.amount_due+': '+money(total-gift)));
      if(gift)card.append(node('small',phrase('preset_saving',gift)));
      const button=node('button',strings.preset_use);button.type='button';button.addEventListener('click',()=>{mount.closest('[data-bundle-builder]').dispatchEvent(new CustomEvent('storm:bundle-preset',{detail:{handles:preset.handles}}));track('preset_selected',{preset:preset.name});});card.append(button);list.append(card);
    });
    if(list.children.length){mount.hidden=false;mount.append(node('h2',strings.preset_heading),node('p',strings.preset_intro),list);}
  });}
  setupPresets();document.addEventListener('shopify:section:load',event=>setupPresets(event.target));
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-storm-three]');if(!button)return;
    const main=button.closest('.sv-product-shell'),id=main?.querySelector('product-form input[name="id"]')?.value||button.dataset.variant,variant=variants.get(String(id));
    const status=statusFor(button);
    if(!variant?.available||variant.min>3||(3-variant.min)%variant.step!==0||variant.max>0&&variant.max<3){if(status){status.hidden=false;status.textContent=strings.quantity_rule;}return;}
    add([{id:Number(id),quantity:3}],button,'same-product-trio');
  });
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>refreshCart(true).catch(()=>{}));
  window.StormSales={track,refreshCart,add};
})();

;
/* Source: storm-recommendations.js */
(() => {
  const configNode=document.getElementById('StormSalesConfig');
  if(!configNode||!window.StormRecommendations)return;
  let config;try{config=JSON.parse(configNode.textContent);}catch{return;}
  const engine=window.StormRecommendations,products=config.products||[],requests=new Map();
  const el=(tag,text,cls)=>{const n=document.createElement(tag);if(text)n.textContent=text;if(cls)n.className=cls;return n;};
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'tr',{style:'currency',currency:config.currency}).format(value/100);
  function native(id,intent){
    const key=id+':'+intent;
    if(!requests.has(key))requests.set(key,fetch(`${config.root}recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=10&intent=${intent}`,{signal:AbortSignal.timeout(5000)})
      .then(r=>{if(!r.ok)throw Error();return r.json();}).then(data=>(data.products||[]).filter(p=>p.available).map(p=>p.id)).catch(()=>[]));
    return requests.get(key);
  }
  engine.native=native;
  class Recommendations extends HTMLElement{
    connectedCallback(){
      if(this.started)return;this.started=true;
      this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'500px'});
      this.observer.observe(this);
    }
    disconnectedCallback(){this.observer?.disconnect();this.started=false;}
    async load(){
      const seed=products.find(p=>String(p.id)===this.dataset.productId);if(!seed)return;
      const intent=this.dataset.intent==='complementary'?'complementary':'related';
      const signals=await native(seed.id,intent);if(!this.isConnected)return;
      const rows=engine.rank(products,[seed],{intent,native:signals,pairs:config.pairs,limit:Number(this.dataset.count)||6});
      this.replaceChildren();if(!rows.length){this.hidden=true;return;}
      const section=el('section',null,'sv-recommendations page-width');
      const header=el('header'),title=el('h2',intent==='related'?'Benzer ürünler':rows.every(r=>r.evidence>=3)?'Birlikte alınanlar':'Paketinizi tamamlayın');
      header.append(title);section.append(header);
      const list=el('ul',null,'sv-recommendations__list');list.setAttribute('role','list');
      rows.forEach(({product:p,reason})=>{
        const item=el('li'),card=el('article',null,'sv-recommendation-card');
        const visual=el('a');visual.href=p.url;visual.setAttribute('aria-label',p.title);
        if(p.image){const img=el('img');img.src=p.image;img.alt=p.title;img.width=320;img.height=320;img.loading='lazy';visual.append(img);}
        const label=el('span',reason,'sv-recommendation-card__reason'),heading=el('h3'),link=el('a',p.title);link.href=p.url;heading.append(link);
        const price=el('strong',money(p.price),'sv-recommendation-card__price');
        const button=el('button',config.strings.add);button.type='button';button.dataset.recommendVariant=String(p.variant);button.setAttribute('aria-label',`${config.strings.add}: ${p.title}`);
        button.addEventListener('click',()=>window.StormSales?.add([{id:Number(p.variant),quantity:1}],button,`recommendation-${intent}`));
        link.addEventListener('click',()=>window.StormSales?.track('recommendation_clicked',{product_id:String(p.id),source_product_id:String(seed.id),intent}));
        card.append(visual,label,heading,price,button);item.append(card);list.append(item);
      });
      const status=el('p',null,'sv-sales-status');status.dataset.salesStatus='';status.setAttribute('role','status');status.hidden=true;
      section.append(list,status);this.append(section);
    }
  }
  if(!customElements.get('storm-recommendations'))customElements.define('storm-recommendations',Recommendations);
})();
